import Script from "next/script";
export const gtmId = "GTM-KKNLZ59";

export const GtmScript = () => {
    if (process.env.NEXT_PUBLIC_ENVIRONMENT !== "production") {
        return null;
    }

    const initialGtmScript = `
    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('consent', 'default', {
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'analytics_storage': 'denied',
        'wait_for_update': 500
    });
    gtag('set', 'ads_data_redaction', true);
    gtag('set', 'url_passthrough', true);
`;

    const gtmScriptString = `
    (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0], 
            j = d.createElement(s), 
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', '${gtmId}');
`;

    return (
        <>
            <Script
                id="gtmInitialScript"
                dangerouslySetInnerHTML={{ __html: initialGtmScript }}
            ></Script>
            <Script
                id="gtmScript"
                strategy="lazyOnload"
                dangerouslySetInnerHTML={{ __html: gtmScriptString }}
            />
        </>
    );
};
